import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const MaintenanceSettingsState = {
  maintenanceSettings: {},
  maintenanceSettingsLoading: false,
}

export const MaintenanceSettingsActions = {
  createMaintenanceSettings: async ({ commit }, value) => {
    commit('setMaintenanceSettingsLoading', true)

    return axiosRequest.
      post('/admin/site_settings', {
        name: 'maintenance',
        value,
      }).
      then(({ data }) => {
        commit('setMaintenanceSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setMaintenanceSettingsLoading', false))
  },

  getMaintenanceSettings: async ({ commit }) => {
    commit('setMaintenanceSettingsLoading', true)

    return axiosRequest.
      get('/admin/site_settings/maintenance').
      then(({ data }) => {
        commit('setMaintenanceSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setMaintenanceSettingsLoading', false))
  },

  updateMaintenanceSettings: async ({ getters, commit }, value) => {
    commit('setMaintenanceSettingsLoading', true)

    return axiosRequest.
      put(`/admin/site_settings/${getters.maintenanceSettingsId}`, {
        name: 'maintenance',
        value,
      }).
      then(({ data }) => {
        commit('setMaintenanceSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setMaintenanceSettingsLoading', false))
  },

  deleteMaintenanceSettings: async ({ getters, commit }) => {
    commit('setMaintenanceSettingsLoading', true)

    return axiosRequest.
      delete(`/admin/site_settings/${getters.maintenanceSettingsId}`).
      then(({ data }) => {
        commit('setMaintenanceSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setMaintenanceSettingsLoading', false))
  },
}

export const MaintenanceSettingsMutations = {
  setMaintenanceSettings: (state, value) => {
    state.maintenanceSettings = value
  },

  setMaintenanceSettingsLoading: (state, value) => {
    state.maintenanceSettingsLoading = value
  },
}

export const MaintenanceSettingsGetters = {
  maintenanceSettings: state => state.maintenanceSettings,
  maintenanceSettingsId: state => state.maintenanceSettings.id,
  maintenanceSettingsLoading: state => state.maintenanceSettingsLoading,
  maintenanceSettingsValue: state => state.maintenanceSettings.value,
}
